import { ZGroupNode } from "../types/ZQueryBuilderTypes";
import { isGroupNode } from "./treeUtils";

export const countCriteria = (group: ZGroupNode): number =>
  group.items.reduce(
    (total, item) => total + (isGroupNode(item) ? countCriteria(item) : 1),
    0,
  );
